export default __webpack_public_path__ + "static/media/LightFixtures-Stacklab1762_.1f6bb2a4.jpg";